// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Comment2: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 55"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M52.8 8.8C47.4 3.4 39.2.3 30.3.3 13.6.3.6 10.9.6 24.4c0 8.1 5.7 13.9 10.5 17.4v11.9c0 .6.5 1 1 1 .1 0 .2 0 .3-.1l2.2-1.1c1.6-.9 5.8-3.4 9.6-7.4 2.1.4 4.6.8 6.8.8 16.9 0 28.2-9 28.2-22.4.1-5.9-2.1-11.3-6.4-15.7zM31.2 44c-2.5 0-5.2-.5-7.1-.9h-.8l-.2.2-.3.4c-3.2 3.5-6.9 6-8.9 7.1V40.4l-.2-.1-.4-.3c-3.7-2.5-9.9-7.8-9.9-15.5C3.4 12.4 15.2 3 30.3 3c15 0 26.3 9.2 26.3 21.4C56.6 36.1 46.4 44 31.2 44z"/><path d="M18.7 19.4c-2.8 0-5.1 2.3-5.1 5.1s2.3 5.1 5.1 5.1 5.1-2.3 5.1-5.1-2.3-5.1-5.1-5.1zm0 2.7c1.3 0 2.4 1.1 2.4 2.4s-1.1 2.4-2.4 2.4-2.4-1.1-2.4-2.4c0-1.3 1.1-2.4 2.4-2.4zm11-2.7c-2.8 0-5.1 2.3-5.1 5.1s2.3 5.1 5.1 5.1 5.1-2.3 5.1-5.1-2.3-5.1-5.1-5.1zm0 7.5c-1.3 0-2.4-1.1-2.4-2.4 0-1.3 1.1-2.4 2.4-2.4 1.3 0 2.4 1.1 2.4 2.4s-1.1 2.4-2.4 2.4zm11-7.5c-2.8 0-5.1 2.3-5.1 5.1s2.3 5.1 5.1 5.1 5.1-2.3 5.1-5.1-2.3-5.1-5.1-5.1zm0 7.5c-1.3 0-2.4-1.1-2.4-2.4 0-1.3 1.1-2.4 2.4-2.4 1.3 0 2.4 1.1 2.4 2.4s-1.1 2.4-2.4 2.4z"/></svg>;
};

export default React.memo(Comment2);
